#import "./TimestampsFull.graphql"
#import "./SearchIndexFull.graphql"

fragment DogFull on Dog {
  id
  birthdate
  breed
  callName
  chipNumber
  registeredName
  handlerOwner
  ...TimestampsFull
  ...SearchIndexFull
}
